import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

export const RichTextEditor = ({ value, onChange, testid }) => {
  const editor = useEditor({
    extensions: [StarterKit.configure({ link: { openOnClick: false } })],
    content: value || "",
    onUpdate: ({ editor: e }) => onChange(e.getHTML()),
  });

  if (!editor) return null;

  const btn = (active) =>
    `px-2.5 py-1.5 font-condensed text-xs font-semibold uppercase tracking-wider transition-colors duration-200 ${
      active ? "bg-charcoal text-offwhite" : "hover:bg-stone-40"
    }`;

  const setLink = () => {
    const url = window.prompt("Link URL", "https://");
    if (url) editor.chain().focus().setLink({ href: url }).run();
  };

  return (
    <div className="border border-charcoal" data-testid={testid}>
      <div className="flex flex-wrap gap-1 border-b border-charcoal px-2 py-1.5">
        <button type="button" className={btn(editor.isActive("heading", { level: 2 }))} onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}>H2</button>
        <button type="button" className={btn(editor.isActive("heading", { level: 3 }))} onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}>H3</button>
        <button type="button" className={btn(editor.isActive("bold"))} onClick={() => editor.chain().focus().toggleBold().run()}>Bold</button>
        <button type="button" className={btn(editor.isActive("italic"))} onClick={() => editor.chain().focus().toggleItalic().run()}>Italic</button>
        <button type="button" className={btn(editor.isActive("blockquote"))} onClick={() => editor.chain().focus().toggleBlockquote().run()}>Quote</button>
        <button type="button" className={btn(editor.isActive("bulletList"))} onClick={() => editor.chain().focus().toggleBulletList().run()}>List</button>
        <button type="button" className={btn(editor.isActive("orderedList"))} onClick={() => editor.chain().focus().toggleOrderedList().run()}>Numbered</button>
        <button type="button" className={btn(editor.isActive("link"))} onClick={setLink}>Link</button>
        <button type="button" className={btn(false)} onClick={() => editor.chain().focus().unsetLink().run()}>Unlink</button>
      </div>
      <EditorContent editor={editor} className="rich-text min-h-[220px] px-4 py-4" />
    </div>
  );
};
